import { userService } from '../services';
import { router } from '../router';

const user = JSON.parse(localStorage.getItem('user'));
const state = user
    ? { status: { loggedIn: true, error: null }, user }
    : { status: { loggedIn: false, error: null }, user: null };

const actions = {
    login({ dispatch, commit }, { username, password, route }) {
        commit('loginRequest', { username });

        userService.login(username, password)
            .then(
                user => {
                    if (user && user.token && user.token !== "") {
                        commit('loginSuccess', user);
                        route ? router.push(route) : router.push('/');
                    } else {
                        var error = "Identificación incorrecta. Asegúrese de que el usuario y la clave son correctos.";
                        commit('loginFailure', error);
                        dispatch('alert/error', error, { root: true });
                    }
                },
                error => {
                    var mensaje = "Identificación incorrecta. Asegúrese de que el usuario y la clave son correctos. " + error;
                    commit('loginFailure', mensaje);
                    dispatch('alert/error', mensaje, { root: true });
                }
            );
    },
    logout({ commit }) {
        userService.logout();
        commit('logout');
    },
    register({ dispatch, commit }, user) {
        commit('registerRequest', user);

        userService.register(user)
            .then(
                user => {
                    commit('registerSuccess', user);
                    router.push('/login');
                    setTimeout(() => {
                        // display success message after route change completes
                        dispatch('alert/success', 'Registration successful', { root: true });
                    })
                },
                error => {
                    commit('registerFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    }
};

const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true, error: null };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggedIn: true, error: null };
        state.user = user;
    },
    loginFailure(state, error) {
        state.status = { error: error};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
    registerRequest(state) {
        state.status = { registering: true };
    },
    registerSuccess(state) {
        state.status = {};
    },
    registerFailure(state) {
        state.status = {};
    }
};

export const account = {
    namespaced: true,
    state,
    actions,
    mutations
};